//import { useSelector, useDispatch } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import React, { ReactNode }  from "react";

interface Props{
    children?: ReactNode;
}


export default function PrivateRouteWrapper(props:Props ) {
//   const login = useSelector((state) => state.login);
//   const { authorized } = login;

const authorized = true;

  return (
    <Route
      render={() =>
        authorized ? (
          props.children
        ) : (
          <Redirect
            to={{ pathname: "/auth/login", }}
          />
        )
      }
    />
  );
}
